export enum ALERT_DISMISS_REASON {

    BACKDROP_CLICK,

    ESC,

    CANCEL,

    PAGE_CHANGE,

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/alerts/alert-dismiss-reasons.ts